module.exports = __webpack_public_path__ + "img/kangmingjian_img5.96577a4f.jpg";